import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { qmsService } from '../qms/qms.service';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-reason-for-signature-template',
  templateUrl: './reason-for-signature-template.component.html',
  styleUrls: ['./reason-for-signature-template.component.scss']
})
export class ReasonForSignatureTemplateComponent implements OnInit {

  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  reasonForSignatureTemplateDataForGrid: any = [];
  reasonForSignatureTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddModule: any = null;
  oddStageName: any = null;
  oddUserRole: any = null;
  oddStatus: any = null;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public qmsService: qmsService) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages


  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.reasonForSignatureTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.reasonForSignatureTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.reasonForSignatureTemplateDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.reasonForSignatureTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.reasonForSignatureTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  focusEmpty() {
    console.log();
  }


  visibelGridData: boolean;
  getcallMethod() {
    if (!this.selectedModule) {
      this.searchFieldValidation();
      return;
    }
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.visibelGridData = true;
    this.reasonForSignatureTemplateDataForGrid = [];
    const data = {

      gridName: "REASON_FOR_SIGNATURE_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "ONEQMS_REASON_FOR_SIGNATURE_TEMPLATE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        if (this.selectedModule) {
          data1.module = this.selectedModule;
        } else {
          data1.module = null;
        }
        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.reasonForSignatureTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            console.log('Data - ', this.reasonForSignatureTemplateDataForGrid);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;


            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const signatureData of this.reasonForSignatureTemplateDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    const columnName = dataType.columnName;
                    signatureData[columnName] = signatureData[columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;

              this.labelcall();
            });

            this.message.gridList = this.reasonForSignatureTemplateDataForGrid;
            this.collectionSize = this.reasonForSignatureTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.reasonForSignatureTemplateDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  dropDownDataForModule: any = [];
  getOneQmsNonorgModuleStagesListDetails: any = [];


  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  ngOnInit() {

    this.dropDownDataForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.selectBoxForModule();

    this.appService.getOneQmsNonorgModuleStagesDetailsByOrgId().subscribe((data: any) => {
      this.getOneQmsNonorgModuleStagesListDetails = data;
    })
    this.isProcessing = false;
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.reasonForSignatureTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.reasonForSignatureTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.reasonForSignatureTemplateDataForGridTemp = this.reasonForSignatureTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.reasonForSignatureTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.reasonForSignatureTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.reasonForSignatureTemplateDataForGrid == undefined) {
        return this.reasonForSignatureTemplateDataForGrid;
      }
      if (!this.reasonForSignatureTemplateDataForGrid.length) {
        return this.reasonForSignatureTemplateDataForGrid;
      }
      if (filter) {
        this.reasonForSignatureTemplateDataForGridTemp = this.reasonForSignatureTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.reasonForSignatureTemplateDataForGridTemp = this.reasonForSignatureTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.reasonForSignatureTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';

          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;
    for (const signatureTemplate of this.reasonForSignatureTemplateDataForGrid) {
      signatureTemplate.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.reasonForSignatureTemplateDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.reasonForSignatureTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  isActiveToggerBoxValue: boolean;
  isActiverFunction(isTagged: boolean) {
    this.isActiveToggerBoxValue = isTagged;
  }
  gridResetFunction() {
    this.selectedModule = null;
    this.selectedModuleValueExp = null;
    this.pagedItems = this.reasonForSignatureTemplateDataForGrid = [];
    this.collectionSize = 0;
  }

  stageNameValue: any;
  userRoleValue: any;
  statusValue: any;
  reasonForSignatureValueReq: any;
  updateReason: any;

  moduleValueRequiredMsg: any;
  stageNameValueRequiredMsg: any;
  userRoleValueRequiredMsg: any;
  statusValueRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  updateReasonRequiredMsg: any;
  fieldValidation() {

    this.stageNameValue = document.getElementById('stageName') as HTMLInputElement;
    this.userRoleValue = document.getElementById('userRole') as HTMLInputElement;
    this.statusValue = document.getElementById('status') as HTMLInputElement;
    this.reasonForSignatureValueReq = document.getElementById('reasonForSignatureValueReq') as HTMLInputElement;
    this.updateReason = document.getElementById('updateReason') as HTMLInputElement;

    this.stageNameValueRequiredMsg = document.getElementById('stageName-required-msg') as HTMLInputElement;
    this.userRoleValueRequiredMsg = document.getElementById('userRole-required-msg') as HTMLInputElement;
    this.statusValueRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.reasonForSignatureRequiredMsg = document.getElementById('reasonForSignature-required-msg') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

    if (this.selectedStageName) {
      this.stageNameValueRequiredMsg.style.display = 'none';
    } else {
      this.stageNameValueRequiredMsg.style.display = 'block';
    }

    if (this.selectedUserRole) {
      this.userRoleValueRequiredMsg.style.display = 'none';
    } else {
      this.userRoleValueRequiredMsg.style.display = 'block';
    }

    if (this.selectedStatus) {
      this.statusValueRequiredMsg.style.display = 'none';
    } else {
      this.statusValueRequiredMsg.style.display = 'block';
    }

    if (this.reasonForSignatureFieldData.reasonForSignature == "") {
      this.reasonForSignatureValueReq.style.border = '1px solid red';
      this.reasonForSignatureRequiredMsg.style.display = 'block';
    } else {
      this.reasonForSignatureValueReq.style.border = 'none';
      this.reasonForSignatureRequiredMsg.style.display = 'none';
    }

  }

  onFieldFocusout() {
    if (this.reasonForSignatureRequiredMsg) {
      this.reasonForSignatureValueReq.style.border = 'none';
      this.reasonForSignatureRequiredMsg.style.display = 'none';
    }

    if (this.updateReasonRequiredMsg) {
      this.updateReason.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    }

    if (this.deleteFiledValueRequiredMsg) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  searchModuleValueRequiredMsg: any;
  searchFieldValidation() {
    this.searchModuleValueRequiredMsg = document.getElementById('searchModule-required-msg') as HTMLInputElement;

    if (this.selectedModuleValueExp) {
      this.searchModuleValueRequiredMsg.style.display = 'none';
    } else {
      this.searchModuleValueRequiredMsg.style.display = 'block';
    }
  }

  reasonForSignatureFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('updateMessagePopup', { static: true }) updateMessagePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleUpdateMessagePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: false,
    position: { top: '10px' },
  };

  updateMessagePopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  refreshGridData() {
    this.getcallMethod();
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  selectedModule: any = null;
  selectedModuleDisplayExp: any = null;
  selectedModuleValueExp: any = null;
  moduleListDropdown: any = [];

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  selectBoxForModule() {
    this.moduleListDropdown = [];

    for (const module of this.dropDownDataForModule) {
      this.moduleListDropdown = this.moduleListDropdown.concat({
        valueExp: module.codelistCode,
        displayExp: module.codelistName
      });
    }
  }

  getOneQmsReasonForSignatureStageValue: any = [];

  modulesearchTxt: any;

  onModuleSelect(event: any, item: any) {
    // 1. Guard Clauses: Exit early if conditions aren't met to avoid nesting
    if (!event.isUserInput) return;

    if (!event.source._selected) {
      this.selectedModule = undefined;
      return;
    }

    if (item) {
      this.isProcessing = true;
      this.stageNameListDropdown = [];

      // 2. Extract the value and handle the API call once
      const moduleValue = item.valueExp ?? item;

      if (moduleValue) {
        this.selectedModuleValueExp = moduleValue;

        // Unified API call (removed duplicate logic)

        this.appService.getDistinctModuleStageName(this.selectedModuleValueExp)
          .subscribe((data: any) => {
            this.getOneQmsReasonForSignatureStageValue = data;
            this.selectBoxForStageName();
          });

        // 3. Optional Chaining for style access
        if (this.searchModuleValueRequiredMsg) {
          this.searchModuleValueRequiredMsg.style.display = 'none';
        }
      }

      this.isProcessing = false;
      this.getcallMethod();
    }
  }



  selectedStageName: any = null;
  selectedStageNameDisplayExp: any = null;
  selectedStageNameValueExp: any = null;
  stageNameListDropdown: any = [];
  selectBoxForStageName() {
    this.stageNameListDropdown = [];

    for (const stage of this.getOneQmsReasonForSignatureStageValue) {
      this.stageNameListDropdown = this.stageNameListDropdown.concat({
        valueExp: stage.stageName,
        displayExp: stage.stageName
      });
    }
  }

  getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName: any = [];
  sepratedStatusListValue: any = [];
  stageNamesearchTxt: any;
  onStageNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.isProcessing = true;
          if (item.displayExp) {
            this.userRoleListDropdown = [];
            this.selectedUserRole = null;

            this.statusListDropdown = [];
            this.selectedStatus = null;
            this.selectedStageNameDisplayExp = item.displayExp;
          } else {
            this.selectedStageNameDisplayExp = item;
          }

          if (this.stageNameValueRequiredMsg) {
            this.stageNameValueRequiredMsg.style.display = 'none';
          }

          this.appService.getReasonForSignOptionsByModuleStageName(this.selectedModuleValueExp, this.selectedStageNameDisplayExp).subscribe((data: any) => {
            this.getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName = data;
            this.sepratedStatusListValue = this.getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName[0].statusList.split(',');
            this.selectBoxs();
            this.isProcessing = false;
          })
        }
      }
    }
  }


  selectedUserRole: any = null;
  selectedUserRoleDisplayExp: any = null;
  selectedUserRoleValueExp: any = null;
  userRoleListDropdown: any = [];

  selectedStatus: any = null;
  selectedStatusDisplayExp: any = null;
  selectedStatusValueExp: any = null;
  statusListDropdown: any = [];
  statusList: any = [];
  selectBoxs() {
    let data: string[] = [];
    this.userRoleListDropdown = [];
    const userRoles = this.getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName[0]?.userRoles;
    if (userRoles !== null && userRoles !== undefined) {
      data = userRoles.split(",");
    }

    for (const role of data) {
      this.userRoleListDropdown = this.userRoleListDropdown.concat({
        valueExp: role,
        displayExp: role
      });
    }

    this.statusList = [];

    for (const statusValue of this.sepratedStatusListValue) {
      const data2 = statusValue.split("/");
      if (data2.length > 1) {
        this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
      } else {
        this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
      }
    }

    for (const status of this.statusList) {
      this.statusListDropdown = this.statusListDropdown.concat({
        valueExp: status.codelistCode,
        displayExp: status.codelistName
      });
    }
  }

  userRolesearchTxt: any;
  onUserRoleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          if (item.valueExp) {
            this.selectedUserRoleValueExp = item.valueExp;
            this.selectedUserRoleDisplayExp = item.displayExp;
          } else {
            this.selectedUserRoleValueExp = item;
            this.selectedUserRoleDisplayExp = item;
          }

          if (this.userRoleValueRequiredMsg) {
            this.userRoleValueRequiredMsg.style.display = 'none';
          }
        }
      }
    }
  }


  statussearchTxt: any;
  onStatusSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          if (item.valueExp) {
            this.selectedStatusValueExp = item.valueExp;
            this.selectedStatusDisplayExp = item.displayExp;
          } else {
            this.selectedStatusValueExp = item;
            this.selectedStatusDisplayExp = item;
          }
          if (this.statusValueRequiredMsg != undefined) {
            this.statusValueRequiredMsg.style.display = 'none';
          }
        }
      }
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  disableModuleDropdown: boolean;
  openAddPopup() {
    if (this.selectedModuleValueExp) {
      this.visibleAddButton = true;
      this.visibleEditButton = false;
      this.visibleReasonForUpdateField = false;
      this.disableModuleDropdown = false;
      this.operationFlag = 'ADD';
      this.popupDataTitle.title = "Create Reason for Signature";

      this.selectedStageName = null;
      this.selectedUserRole = null;
      this.selectedStatus = null;
      this.userRoleListDropdown = [];
      this.statusListDropdown = [];
      this.reasonForSignatureFieldData.reasonForSignature = '';
      this.reasonForSignatureFieldData.isActive = true;
      this.reasonForSignatureFieldData.belongsToIndividual = false;
      this.reasonForSignatureFieldData.updateReason = '';
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    }
    else {
      this.searchFieldValidation();
    }
  }

  previousData: any;
  previousDataTemplateId: any;
  getOneQmsReasonForSignatureVwEditDetails: any = [];
  filteredModulaeValue: any = [];
  filteredStageNameValue: any = [];
  filteredUserRoleValue: any = [];
  filteredStatusValue: any = [];
  filteredListOfStatusValue: any = [];
  listOfoneQmsNonorgModuleStagesData: any = [];
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }

  }
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.stageNameListDropdown = [];
    this.selectedStageName = null;
    this.userRoleListDropdown = [];
    this.selectedUserRole = null;
    this.statusListDropdown = [];
    this.selectedStatus = null;
    this.previousData = editRowData;

    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.operationFlag = 'EDIT';
      this.popupDataTitle.title = "Update Reason for Signature";
    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.popupDataTitle.title = "Info";
    }

    this.visibleReasonForUpdateField = true;
    this.previousDataTemplateId = editRowData.TEMPLATE_ID;
    this.appService.getReasonForSignByTemplateId(editRowData.TEMPLATE_ID).subscribe((response: any) => {
      this.getOneQmsReasonForSignatureVwEditDetails = response

      this.appService.getReasonForSignOptionsByModuleStageName(this.getOneQmsReasonForSignatureVwEditDetails.module, this.getOneQmsReasonForSignatureVwEditDetails.stageName).subscribe((data: any) => {
        this.getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName = data;

        this.reasonForSignatureFieldData.templateId = this.getOneQmsReasonForSignatureVwEditDetails.templateId;
        this.reasonForSignatureFieldData.reasonForSignature = this.getOneQmsReasonForSignatureVwEditDetails.reasonForSignature;
        this.reasonForSignatureFieldData.isActive = this.getOneQmsReasonForSignatureVwEditDetails.isActive == 'Y';
        this.reasonForSignatureFieldData.belongsToIndividual = this.getOneQmsReasonForSignatureVwEditDetails.belongsToIndividual == 'Y';


        if (this.getOneQmsReasonForSignatureVwEditDetails.module) {
          const matchingModule = this.dropDownDataForModule?.find((item: any) => item.codelistCode == this.getOneQmsReasonForSignatureVwEditDetails.module);
          if (!matchingModule) {
            this.oddModule = this.getOneQmsReasonForSignatureVwEditDetails.module;
            this.moduleListDropdown.push({
              valueExp: this.getOneQmsReasonForSignatureVwEditDetails.module,
              displayExp: this.getOneQmsReasonForSignatureVwEditDetails.module
            })
          }
          this.selectedModule = this.getOneQmsReasonForSignatureVwEditDetails.module;
        }


        if (this.getOneQmsReasonForSignatureVwEditDetails.stageName) {
          const matchingStageName = this.getOneQmsReasonForSignatureStageValue?.find((item: any) => item.stageName == this.getOneQmsReasonForSignatureVwEditDetails.stageName);
          if (!matchingStageName) {
            this.oddStageName = this.getOneQmsReasonForSignatureVwEditDetails.stageName;
            this.stageNameListDropdown.push({
              valueExp: this.getOneQmsReasonForSignatureVwEditDetails.stageName,
              displayExp: this.getOneQmsReasonForSignatureVwEditDetails.stageName
            })
          }
          this.selectedStageName = this.getOneQmsReasonForSignatureVwEditDetails.stageName;
        }

        if (this.getOneQmsReasonForSignatureVwEditDetails.userRole) {
          const matchingUserRoles = this.getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName?.find((item: any) => item.userRoles == this.getOneQmsReasonForSignatureVwEditDetails.userRole);
          if (!matchingUserRoles) {
            this.oddUserRole = this.getOneQmsReasonForSignatureVwEditDetails.userRole;
            this.userRoleListDropdown.push({
              valueExp: this.getOneQmsReasonForSignatureVwEditDetails.userRole,
              displayExp: this.getOneQmsReasonForSignatureVwEditDetails.userRole
            })
          }
          this.selectedUserRole = this.getOneQmsReasonForSignatureVwEditDetails.userRole;
        }
        if (this.getOneQmsReasonForSignatureVwEditDetails.status) {
          this.statusListDropdown = [];

          const listOfStatusData = this.getOneQmsReasonForSignatureStageOptionsVwDetailsByStageName.find(
            (x: any) => x.stageName === this.getOneQmsReasonForSignatureVwEditDetails.stageName
          );

          // FIX: Removed [0] and added a safety check
          if (listOfStatusData?.statusList) {
            this.sepratedStatusListValue = listOfStatusData.statusList.split(',');
            let tempsplitedStatusList = [];
            let tempValueExp = [];

            for (const statusValue of this.sepratedStatusListValue) {
              const splitedList = statusValue.split("/");
              tempsplitedStatusList.push(splitedList[0].trim());

              if (splitedList[1]) {
                tempValueExp.push(splitedList[1].trim());
              } else {
                tempValueExp.push(splitedList[0].trim());
              }
              this.statusList = tempsplitedStatusList;
            }

            if (this.statusList.length > 0) {
              const matchingStatus = tempValueExp?.find((item: any) => item == this.getOneQmsReasonForSignatureVwEditDetails.status);
              if (!matchingStatus) {
                this.oddStatus = this.getOneQmsReasonForSignatureVwEditDetails.status;
                this.statusListDropdown.push({
                  valueExp: this.getOneQmsReasonForSignatureVwEditDetails.status,
                  displayExp: this.getOneQmsReasonForSignatureVwEditDetails.status
                })
              }
              this.selectedStatus = this.getOneQmsReasonForSignatureVwEditDetails.status;
            }
          }
        } else {
          this.selectedStatus = null;
        }


        this.onModuleSelect(this.event, this.getOneQmsReasonForSignatureVwEditDetails.module);
        this.onStageNameSelect(this.event, this.getOneQmsReasonForSignatureVwEditDetails.stageName);
        this.onUserRoleSelect(this.event, this.getOneQmsReasonForSignatureVwEditDetails.userRole);
        this.onStatusSelect(this.event, this.getOneQmsReasonForSignatureVwEditDetails.status);

        this.isProcessing = false;

      })

    })

    this.reasonForSignatureFieldData.updateReason = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  addAndEditFunction(reasonForSignatureFieldData: any) {
    this.isProcessing = true;
    if (!this.selectedModule || !this.selectedStageName || !this.selectedUserRole
      || !this.selectedStatus || reasonForSignatureFieldData.reasonForSignature == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.selectedStatus) {
        this.selectedStatusValueExp = this.selectedStatus.trim();
      }
      let data = {
        reasonForSignature: reasonForSignatureFieldData.reasonForSignature,
        updateReason: reasonForSignatureFieldData.updateReason,
        isActive: reasonForSignatureFieldData.isActive ? 'Y' : 'N',
        belongsToIndividual: reasonForSignatureFieldData.belongsToIndividual ? 'Y' : 'N',
        module: this.selectedModule ?? null,
        stageName: this.selectedStageName ?? "",
        userRole: this.selectedUserRole ?? "",
        status: this.selectedStatus ?? "",
      }
      if (this.operationFlag == 'ADD') {
        this.appService.createReasonForSignature(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        if (this.reasonForSignatureFieldData.updateReason == null || this.reasonForSignatureFieldData.updateReason == undefined || this.reasonForSignatureFieldData.updateReason == '') {
          this.updateReason = document.getElementById('updateReason') as HTMLInputElement;
          this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
          this.updateReason.style.border = '1px solid red';
          this.updateReasonRequiredMsg.style.display = 'block';
          this.isProcessing = false;
        } else {
          delete reasonForSignatureFieldData.createdOn;
          delete reasonForSignatureFieldData.updatedOn;

          let modifiedData = {
            ...data,
            reasonForSignatureTemplateVwPk: {
              templateId: this.previousDataTemplateId,
            }
          }
          this.appService.updateReasonForSignature(modifiedData).subscribe({
            next: (Response: any) => {
              if (Response.resultType == 'S') {
                this.visibleAddAndEditPopup.close();
                this.getcallMethod();
              }
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }, error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });
        }
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteReasonForSignatureTemplateId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Reason for Signature";
    this.deleteReasonForSignatureTemplateId = deleteRowData.TEMPLATE_ID;
    if (this.reasonForSignatureFieldData.deleteReason != undefined) {
      this.reasonForSignatureFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction(reasonForSignatureFieldData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      reasonForSignatureFieldData.reasonForSignatureTemplateVwPk = {
        templateId: this.deleteReasonForSignatureTemplateId
      };
      reasonForSignatureFieldData.deleteReason = this.reasonForSignatureFieldData.deleteReason;
      this.appService.deleteReasonForSignature(reasonForSignatureFieldData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, reasonForSignature: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : reasonForSignature.TEMPLATE_ID;
    this.auditTrail.gridName = 'REASON_FOR_SIGNATURE_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Reason for Signature Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(reasonForSignature);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Reason for Signature Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };


}
